export default __webpack_public_path__ + "static/media/filterOrSortIcon.80cc315a.svg";